module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_0.cc1d5c7e.png";